// extracted by mini-css-extract-plugin
export default {"button":"fgHLUq","container":"GcE_Hs","loader":"ROSx2b"};